import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import * as Yup from "yup";


import LocationSearchDropdown from "../components/LocationDropDown";
import { addFile } from "../../services/Admin/adminServices";
import toast from "react-hot-toast";

const EditServiceModal = ({ show, handleClose, initialData, onSubmit }) => {
  //  const initialValues = {
  //   title: initialData.title,
  //   email: initialData.email,
  //   countryCodes: initialData.countryCodes,
  //   phoneNumber: initialData.phoneNumber,
  //   description: initialData.description,
  //   address: {
  //     name: initialData.address.name,
  //     city:initialData.address.city,
  //     state: initialData.address.state,
  //     streetAddress: initialData.address.streetAddress,
  //     pincode:  initialData.address.pincode,
  //     location: {
  //       type: "Point",
  //       coordinates:[1233,1232],
  //     },
  //   },
  //   accessSupport: [
  //     {
  //       office: initialData.accessSupport.office,
  //       name:initialData.accessSupport.name,
  //       phoneNumber: [
  //         { title: "Primary", number: initialData.accessSupport[0].number },
  //         { title: "Emergency",  number: initialData.accessSupport[1].number },
  //       ],
  //       email: [initialData.accessSupport.email],
  //       post: initialData.accessSupport.post,
  //       location: {
  //         name: initialData?.accessSupport.location.city,
  //         city: initialData?.accessSupport.location.city,
  //         state: initialData?.accessSupport.location.state,
  //         streetAddress:initialData?.accessSupport.location.streetAddress,
  //         pincode: initialData?.accessSupport.location.pincode,
  //       },
  //     },
  //   ],
  // };
  // {
  //     ...initialData,
  //     serviceId: initialData?._id
  //   }
  const [previewFile, setPreviewFile] = React.useState(initialData?.logo ? (initialData.logo.startsWith("http") ? initialData.logo : "https://api.socialjusticejamaica.com" + initialData.logo) : null);
  const [previewBanner, setPreviewBanner] = React.useState(initialData?.banner ? (initialData.banner.startsWith("http") ? initialData.banner : "https://api.socialjusticejamaica.com" + initialData.banner) : null);
  const [uploadingLogo, setUploadingLogo] = React.useState(false);
  const [uploadingBanner, setUploadingBanner] = React.useState(false);
  const formattedDescription = Array.isArray(initialData?.description)
    ? (initialData.description.length > 0
        ? initialData.description
        : [{ question: "", answer: "" }])
    : typeof initialData?.description === "string" && initialData.description.trim() !== ""
    ? [{ question: "What is this service?", answer: initialData.description }]
    : [{ question: "", answer: "" }];

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title className="titleColor">Edit Service</Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={{
          ...initialData,
          description: formattedDescription,
          serviceId: initialData?._id,
        }}
        validationSchema={Yup.object({
          shortDescription: Yup.string()
            .test(
              "maxWords",
              "Short description cannot exceed 200 words",
              (value) => {
                if (!value) return true;
                const count = value.trim().split(/\s+/).filter(Boolean).length;
                return count <= 200;
              }
            ),
        })}
        enableReinitialize

        onSubmit={async (values, { setSubmitting }) => {
          await onSubmit(values, setSubmitting);
        }}
      >
        {({ values, setFieldValue, isSubmitting }) => {


          return (
            <Form>
              <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
                {/* Title */}
                <div className="mb-3">
                  <label className="form-label">Title</label>
                  <Field
                    name="title"
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                  />
                </div>

                {/* Email */}
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <Field
                    name="email"
                    type="email"
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                  />
                </div>


                {/* Phone */}
                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <PhoneInput
                    country={"us"}
                    value={`${values.countryCodes}${values.phoneNumber}`}
                    onChange={(value, country) => {
                      let dialCode = country.dialCode;


                      let onlyNumber = value.startsWith(dialCode)
                        ? value.slice(dialCode.length)
                        : value;

                      onlyNumber = onlyNumber.replace(/^0+/, "");

                      setFieldValue("countryCodes", "+" + dialCode);
                      setFieldValue("phoneNumber", onlyNumber);
                    }}
                    inputClass="form-control w-100 w-md-50"
                    style={{ borderColor: "#0AB7EA" }}
                  />
                </div>





                <div className="mb-3">
                  <label className="form-label">Logo</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (!file) return;

                      const formData = new FormData();
                      formData.append("files", file);

                      try {
                        setUploadingLogo(true);
                        const res = await addFile(formData);
                        setUploadingLogo(false);

                        setPreviewFile(URL.createObjectURL(file));
                        setFieldValue("logo", res?.data?.data?.files[0].path);
                      } catch (error) {
                        setUploadingLogo(false);
                        toast.error("File upload failed!");
                      }
                    }}
                  />

                  {/* Preview + remove */}
                  {previewFile && (
                    <div className="mt-3 position-relative" style={{ width: "180px" }}>
                      <img
                        src={previewFile}
                        alt="Preview"
                        className="img-fluid rounded shadow"
                        style={{ maxHeight: "160px", objectFit: "cover" }}
                      />
                      <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: "-10px", right: "-10px", borderRadius: "50%" }}
                        onClick={() => {
                          setPreviewFile(null);
                          setFieldValue("logo", "");
                        }}
                      >
                        X
                      </button>
                    </div>
                  )}

                  {uploadingLogo && (
                    <div className="text-primary mt-2 fw-semibold">
                      Uploading logo...
                    </div>
                  )}
                </div>

                {/* Short Description */}
                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <label className="form-label mb-0">Short Description</label>
                    <span
                      className={`small ${
                        ((values.shortDescription || "").trim().split(/\s+/).filter(Boolean).length > 200)
                          ? "text-danger fw-bold"
                          : "text-muted"
                      }`}
                    >
                      {(values.shortDescription || "").trim().split(/\s+/).filter(Boolean).length} / 200 words
                    </span>
                  </div>
                  <Field
                    name="shortDescription"
                    as="textarea"
                    rows={2}
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                    placeholder="Enter short description (max 200 words)..."
                  />
                  <ErrorMessage name="shortDescription" component="div" className="text-danger mt-1" />
                </div>

                {/* Upload Banner */}
                <div className="mb-3">
                  <label className="form-label">Banner Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (!file) return;

                      const formData = new FormData();
                      formData.append("files", file);

                      try {
                        setUploadingBanner(true);
                        const res = await addFile(formData);
                        setUploadingBanner(false);

                        setPreviewBanner(URL.createObjectURL(file));
                        setFieldValue("banner", res?.data?.data?.files[0].path);
                      } catch (error) {
                        setUploadingBanner(false);
                        toast.error("Banner upload failed!");
                      }
                    }}
                  />

                  {previewBanner && (
                    <div className="mt-3 position-relative" style={{ width: "240px" }}>
                      <img
                        src={previewBanner}
                        alt="Banner Preview"
                        className="img-fluid rounded shadow"
                        style={{ maxHeight: "140px", width: "100%", objectFit: "cover" }}
                      />
                      <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: "-10px", right: "-10px", borderRadius: "50%" }}
                        onClick={() => {
                          setPreviewBanner(null);
                          setFieldValue("banner", "");
                        }}
                      >
                        X
                      </button>
                    </div>
                  )}

                  {uploadingBanner && (
                    <div className="text-primary mt-2 fw-semibold">
                      Uploading banner image...
                    </div>
                  )}
                </div>

                {/* Description */}
                <FieldArray name="description">
                  {({ push, remove }) => (
                    <div className="mt-4 mb-3">
                      <h5>Description</h5>
                      {values.description && values.description.length > 0
                        ? values.description.map((item, index) => (
                            <div key={index} className="border rounded p-3 mb-3 bg-light">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6>Description Item #{index + 1}</h6>
                                {values.description.length > 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </button>
                                )}
                              </div>

                              <div className="mb-2">
                                <label className="form-label">Question</label>
                                <Field
                                  name={`description.${index}.question`}
                                  className="form-control"
                                  style={{ borderColor: "#0AB7EA" }}
                                  placeholder="e.g. What is this service?"
                                />
                              </div>

                              <div className="mb-2">
                                <label className="form-label">Answer</label>
                                <Field
                                  as="textarea"
                                  name={`description.${index}.answer`}
                                  className="form-control"
                                  style={{ borderColor: "#0AB7EA" }}
                                  rows={3}
                                  placeholder="e.g. Free legal aid for community members"
                                />
                              </div>
                            </div>
                          ))
                        : null}

                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => push({ question: "", answer: "" })}
                      >
                        + Add Description Item
                      </button>
                    </div>
                  )}
                </FieldArray>

                {/* Address */}
                <h5 className="mt-4">Address</h5>



                <div className="mb-3">
                  <label className="form-label">Office Name</label>
                  <Field
                    name={`address.name`}
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                  />
                </div>





                <div className="mb-2">
                  <label className="form-label">street address  </label>
                  <Field name="address.streetAddress">
                    {({ form, field }) => (
                      <LocationSearchDropdown
                        value={field.value}
                        onSelect={(location) => {

                          form.setFieldValue("address.city", location.city || "");
                          form.setFieldValue("address.state", location.state || "");
                          form.setFieldValue("address.streetAddress", location.name || "");
                          form.setFieldValue("address.pincode", location.pincode || "");
                          form.setFieldValue("address.location.type", location.location.type || "");
                          form.setFieldValue("address.location.coordinates[0]", location.location.coordinates[0] || "");
                          form.setFieldValue("address.location.coordinates[1]", location.location.coordinates[1] || "");
                        }}
                      />
                    )}
                  </Field>
                </div>





                {["city", "state", "pincode"].map(
                  (field) => (
                    <div className="mb-3" key={field}>
                      <label className="form-label">{field}</label>
                      <Field
                        name={`address.${field}`}
                        className="form-control"
                        style={{ borderColor: "#0AB7EA" }}
                      />
                    </div>
                  )
                )}

                {/* Access Support */}
                <FieldArray name="accessSupport">
                  {({ push, remove }) => (
                    <div>
                      <h5 className="mt-4">Access Support</h5>

                      {values.accessSupport.map((support, index) => (
                        <div
                          key={index}
                          className="border rounded p-3 mb-3 bg-light"
                        >
                          <div className="d-flex justify-content-between">
                            <h6>Support #{index + 1}</h6>
                            {values.accessSupport.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => remove(index)}
                              >
                                Remove
                              </button>
                            )}
                          </div>

                          {/* Office */}
                          <div className="mb-2">
                            <label className="form-label">Office</label>
                            <Field
                              name={`accessSupport.${index}.office`}
                              className="form-control"
                              style={{ borderColor: "#0AB7EA" }}
                            />
                          </div>

                          {/* Name */}
                          <div className="mb-2">
                            <label className="form-label">Name</label>
                            <Field
                              name={`accessSupport.${index}.name`}
                              className="form-control"
                              style={{ borderColor: "#0AB7EA" }}
                            />
                          </div>

                          {/* Post */}
                          <div className="mb-2">
                            <label className="form-label">Post</label>
                            <Field
                              name={`accessSupport.${index}.post`}
                              className="form-control"
                              style={{ borderColor: "#0AB7EA" }}
                            />
                          </div>

                          {/* Phone Numbers */}
                          <div className="mb-3">
                            <label className="form-label">Phone Numbers</label>
                            {support.phoneNumber.map((ph, phIndex) => (
                              <div
                                key={phIndex}
                                className="d-flex flex-column flex-md-row gap-2 mb-2 align-items-md-center "
                              >
                                <Field
                                  name={`accessSupport.${index}.phoneNumber.${phIndex}.title`}
                                  className="form-control"
                                  disabled
                                  style={{
                                    borderColor: "#0AB7EA",
                                    maxWidth: "120px",
                                  }}
                                />

                                <PhoneInput
                                  country={"us"}
                                  value={ph.number}
                                  name={`accessSupport.${index}.phoneNumber.${phIndex}.number`}
                                  onChange={(value, country) => {
                                    let dialCode = country.dialCode;
                                    let onlyNumber = value.startsWith(dialCode)
                                      ? value.slice(dialCode.length)
                                      : value;

                                    onlyNumber = onlyNumber.replace(/^0+/, "");

                                    const formattedNumber = `+${country.dialCode} ${onlyNumber}`;
                                    setFieldValue(
                                      `accessSupport.${index}.phoneNumber.${phIndex}.number`,
                                      formattedNumber
                                    );
                                  }}
                                  inputClass="form-control w-100 w-md-50"
                                  style={{ borderColor: "#0AB7EA" }}
                                />
                              </div>
                            ))}
                          </div>

                          {/* Emails */}
                          <FieldArray name={`accessSupport.${index}.email`}>
                            {({ push, remove }) => (
                              <div className="mt-3">
                                <label className="form-label">Emails</label>
                                {support.email.map((em, emIndex) => (
                                  <div
                                    key={emIndex}
                                    className="d-flex gap-2 mb-2"
                                  >
                                    <Field
                                      name={`accessSupport.${index}.email.${emIndex}`}
                                      className="form-control"
                                      type="email"
                                      placeholder="Enter email"
                                      style={{ borderColor: "#0AB7EA" }}
                                    />
                                    {support.email.length > 1 && (
                                      <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => remove(emIndex)}
                                      >
                                        X
                                      </button>
                                    )}
                                  </div>
                                ))}
                                <button
                                  type="button"
                                  className="btn btn-secondary btn-sm"
                                  onClick={() => push("")}
                                >
                                  + Add Email
                                </button>
                              </div>
                            )}
                          </FieldArray>






















                          {/* Location */}

                          <div className="mt-3">



                            <label className="form-label">Office Name</label>

                            <Field
                              name={`accessSupport.${index}.location.name`}
                              className="form-control mb-2"
                              placeholder="Location Name"
                              style={{ borderColor: "#0AB7EA" }}
                            />
                            <div className="row">




                              <div className="col-md-6 mb-2">
                                <label className="form-label">Street</label>

                                <Field name={`accessSupport.${index}.location.streetAddress`}>
                                  {({ form, field }) => (
                                    <LocationSearchDropdown
                                      value={field.value}
                                      onSelect={(location) => {


                                        form.setFieldValue(`accessSupport.${index}.location.city`, location.city || "");
                                        form.setFieldValue(`accessSupport.${index}.location.state`, location.state || "");
                                        form.setFieldValue(`accessSupport.${index}.location.streetAddress`, location.name || "");
                                        form.setFieldValue(`accessSupport.${index}.location.pincode`, location.pincode || "");
                                        form.setFieldValue(`accessSupport.${index}.location.location.type`, location.location.type || "");
                                        form.setFieldValue(`accessSupport.${index}.location.location.coordinates[0]`, location.location.coordinates[0] || "");
                                        form.setFieldValue(`accessSupport.${index}.location.location.coordinates[1]`, location.location.coordinates[1] || "");
                                      }}
                                    />
                                  )}
                                </Field>


                              </div>






                              <div className="col-md-6 mb-2">
                                <label className="form-label">State</label>
                                <Field
                                  name={`accessSupport.${index}.location.state`}
                                  className="form-control"
                                  placeholder="State"
                                  style={{ borderColor: "#0AB7EA" }}
                                />
                              </div>



                              <div className="col-md-6 mb-2">
                                <label className="form-label">City</label>
                                <Field
                                  name={`accessSupport.${index}.location.city`}
                                  className="form-control"
                                  placeholder="City"
                                  style={{ borderColor: "#0AB7EA" }}
                                />
                              </div>

                              <div className="col-md-6 mb-2">
                                <label className="form-label">Pincode</label>
                                <Field
                                  name={`accessSupport.${index}.location.pincode`}
                                  className="form-control"
                                  placeholder="Pincode"
                                  style={{ borderColor: "#0AB7EA" }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      {/* ✅ Add new full Access Support block */}
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() =>
                          push({
                            office: "",
                            name: "",
                            post: "",
                            phoneNumber: [
                              { title: "Primary", number: "" },
                              { title: "Emergency", number: "" },
                            ],
                            email: [""],
                            location: {
                              name: "",
                              city: "",
                              state: "",
                              streetAddress: "",
                              pincode: "",
                            },
                          })
                        }
                      >
                        + Add Access Support
                      </button>
                    </div>
                  )}
                </FieldArray>








                <FieldArray name="faq">
                  {({ push, remove }) => (
                    <div className="mt-4">
                      <h5>FAQ</h5>
                      {values.faq && values.faq.length > 0
                        ? values.faq.map((item, index) => (
                          <div key={index} className="border rounded p-3 mb-3 bg-light">
                            <div className="d-flex justify-content-between">
                              <h6>FAQ #{index + 1}</h6>
                              {values.faq.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => remove(index)}
                                >
                                  Remove
                                </button>
                              )}
                            </div>

                            <div className="mb-2">
                              <label className="form-label">Question</label>
                              <Field
                                name={`faq.${index}.question`}
                                className="form-control"
                                style={{ borderColor: "#0AB7EA" }}
                              />
                            </div>

                            <div className="mb-2">
                              <label className="form-label">Answer</label>
                              <Field
                                as="textarea"
                                name={`faq.${index}.answer`}
                                className="form-control"
                                style={{ borderColor: "#0AB7EA" }}
                                rows={3}
                              />
                            </div>
                          </div>
                        ))
                        : null}

                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => push({ question: "", answer: "" })}
                      >
                        + Add FAQ
                      </button>
                    </div>
                  )}
                </FieldArray>








              </Modal.Body>

              <Modal.Footer
                style={{
                  position: "sticky",
                  bottom: 0,
                  background: "#fff",
                  zIndex: 1000,
                  padding: "1rem",
                  borderTop: "1px solid #dee2e6",
                }}
              >
                <Button variant="secondary" onClick={handleClose}>
                  Cancel
                </Button>
                <Button type="submit" style={{ backgroundColor: "#0AB7EA", border: "none" }} variant="primary" disabled={isSubmitting || uploadingLogo || uploadingBanner}>
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Saving Changes...
                    </>
                  ) : (
                    "Save Changes"
                  )}
                </Button>
              </Modal.Footer>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default EditServiceModal;
